import React from "react";
import { Link } from "react-router-dom";
import { FaArrowCircleRight } from "react-icons/fa";


function MoreContent() {
  return (
    <div className="bg-slate-50 text-slate-800 antialiased font-['Plus_Jakarta_Sans',sans-serif]">
      {/* Dynamic CSS styles for 3D perspective and card hover effects matching HTML design */}
      <style>{`
        .perspective-1000 {
          perspective: 1000px;
        }
        .preserve-3d {
          transform-style: preserve-3d;
          transition: transform 0.5s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 0.5s ease;
        }
        .preserve-3d:hover {
          transform: translateY(-8px) rotateX(4deg) rotateY(-3deg);
        }
      `}</style>

      {/* 5. VALUE PROPOSITION SECTION */}
      <section className="py-16 bg-white border-y border-slate-200">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
            Don't Compare the Price,{" "}
            <span className="text-emerald-600">Compare the Quality.</span>
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed font-normal">
True value lies not in what you save today but in the lasting satisfaction you gain tomorrow. Quality ensures trust, durability, and long-term benefits that far outweigh short-term cost savings.          </p>
        </div>
      </section>

      {/* 7. 3D HOVER CARDS (ABOUT, MISSION, VISION) IN LIGHT THEME */}
      <section id="about" className="py-20 bg-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            
            {/* About Us Card */}
            <div className="perspective-1000">
              <div className="preserve-3d bg-blue-900 text-white p-8 rounded-3xl shadow-xl flex flex-col justify-between h-full relative group">
                <div className="space-y-4">
                  <span className="text-xs font-bold uppercase tracking-widest text-blue-300">
                    Who We Are
                  </span>
                  <h3 className="text-2xl font-bold">About Us</h3>
                  <p className="text-blue-100 text-sm leading-relaxed">
A SEBI-registered  Research Analyst providing accurate, unbiased research on securities, commodities, and currencies. We analyze financial performance and market trends to help you make informed investment decisions.                  </p>
                </div>
                <div className="mt-8">
                  <Link
                    to="/aboutus"
                    className="inline-flex items-center text-xs font-bold text-blue-200 group-hover:text-white gap-2 uppercase tracking-wider"
                  >
                   Learn More<FaArrowCircleRight />
                  </Link>
                </div>
              </div>
            </div>

            {/* Our Mission Card */}
            <div className="perspective-1000">
              <div className="preserve-3d bg-emerald-700 text-white p-8 rounded-3xl shadow-xl flex flex-col justify-between h-full relative group">
                <div className="space-y-4">
                  <span className="text-xs font-bold uppercase tracking-widest text-emerald-200">
                    Our Core Purpose
                  </span>
                  <h3 className="text-2xl font-bold">Our Mission</h3>
                  <p className="text-emerald-100 text-sm leading-relaxed">
                    We aim to provide accurate and timely research, analysis, and recommendations to investors, enabling them to make informed decisions and achieve their financial goals.To empower retail and institutional market participants with precise, transparent, and actionable equity recommendations that cultivate long-term wealth.
                  </p>
                </div>
                <div className="mt-8">
                  <Link
                    to="/aboutus"
                    className="inline-flex items-center text-xs font-bold text-emerald-200 group-hover:text-white gap-2 uppercase tracking-wider"
                  >
                    Learn how we help you <FaArrowCircleRight />
                  </Link>
                </div>
              </div>
            </div>

            {/* Our Vision Card */}
            <div className="perspective-1000">
              <div className="preserve-3d bg-indigo-900 text-white p-8 rounded-3xl shadow-xl flex flex-col justify-between h-full relative group">
                <div className="space-y-4">
                  <span className="text-xs font-bold uppercase tracking-widest text-indigo-300">
                    Our Future
                  </span>
                  <h3 className="text-2xl font-bold">Our Vision</h3>
                  <p className="text-indigo-100 text-sm leading-relaxed">
To empower investors with knowledge and security through unbiased, transparent, and reliable research.                  </p>
                </div>
                <div className="mt-8">
                  <Link
                    to="/aboutus"
                    className="inline-flex items-center text-xs font-bold text-indigo-200 group-hover:text-white gap-2 uppercase tracking-wider"
                  >
                    See the future with us <FaArrowCircleRight />
                  </Link>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}

export default MoreContent;